import common from '@/util/components/common'
import tool from '@/util/components/tool'
import {
    request
} from '@/util/components/request'

export default {
    common,
    tool,
    request
}
